export default "<p>patrocinio works!</p>\n"